import { render, staticRenderFns } from "./individualCalls.vue?vue&type=template&id=1b2a3f4c&scoped=true"
import script from "./individualCalls.vue?vue&type=script&lang=js"
export * from "./individualCalls.vue?vue&type=script&lang=js"
import style0 from "./individualCalls.vue?vue&type=style&index=0&id=1b2a3f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a3f4c",
  null
  
)

export default component.exports